import React from "react";
import { TabGroup, TabList, Tab } from "@headlessui/react";
import { Plane, Train, Bus, PenLine } from "lucide-react";
import useTransportStore from "@/stores/tripBuilder/useTransport";
import { toast } from "@/hooks/use-toast";

interface TopBarProps {
  isAdmin: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ isAdmin }) => {
  const { activeTransportMode, setActiveTransportMode } = useTransportStore();

  return (
    <div className="w-full space-y-3">
      <TabGroup
        selectedIndex={
          activeTransportMode === "flights"
            ? 0
            : activeTransportMode === "trains"
            ? 1
            : activeTransportMode === "buses"
            ? 2
            : 3
        }
        onChange={(index) => {
          if (!isAdmin && index === 3) {
            toast({
              title: "Viewer access restricted",
              description: "Create a copy of this trip to add custom transport",
              duration: 3000,
            });
          } else {
            setActiveTransportMode(
              index === 0
                ? "flights"
                : index === 1
                ? "trains"
                : index === 2
                ? "buses"
                : "custom"
            );
          }
        }}
        className="w-full"
      >
        <TabList className="flex flex-row w-full space-x-2">
          <Tab className="rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700 focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out">
            <Plane className="w-4 h-4" />
            <span>Flights</span>
          </Tab>
          <Tab className="rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700 focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out">
            <Train className="w-4 h-4" />
            <span>Trains</span>
          </Tab>
          <Tab className="rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700 focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out">
            <Bus className="w-4 h-4" />
            <span>Buses</span>
          </Tab>
          <Tab
            className={`rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium ${
              !isAdmin
                ? "opacity-20"
                : "text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700"
            } focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out`}
          >
            <PenLine className="w-4 h-4" />
            <span>Custom</span>
          </Tab>
        </TabList>
      </TabGroup>
    </div>
  );
};

export default TopBar;
